import { render, staticRenderFns } from "./SignUpOtp.vue?vue&type=template&id=b76e6312&scoped=true"
import script from "./SignUpOtp.vue?vue&type=script&lang=js"
export * from "./SignUpOtp.vue?vue&type=script&lang=js"
import style0 from "./SignUpOtp.vue?vue&type=style&index=0&id=b76e6312&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b76e6312",
  null
  
)

export default component.exports